/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectContactPaymentDataDto } from './subjectContactPaymentDataDto.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { SubjectType } from './subjectType.model';
import { SubjectSource } from './subjectSource.model';
import { HouseNumberType } from './houseNumberType.model';


export interface SubjectContactBaseResponseDto { 
    actualised?: boolean;
    cadastralCastObce?: string;
    cadastralCisloDomovni?: number;
    cadastralCisloOrientacni?: string;
    cadastralCpCe?: HouseNumberType;
    cadastralIco?: string;
    cadastralJmeno?: string;
    cadastralMestskaCast?: string;
    cadastralNazev?: string;
    cadastralObec?: string;
    cadastralOkres?: string;
    cadastralPrijmeni?: string;
    cadastralPsc?: string;
    cadastralRodneCislo?: string;
    cadastralStat?: string;
    cadastralTitulPredJmenem?: string;
    cadastralTitulZaJmenem?: string;
    cadastralUlice?: string;
    cadastralUliceKompletni?: string;
    castObce?: string;
    charosKod?: number;
    charosNazev?: string;
    cisloDomovni?: number;
    cisloOrientacni?: string;
    consigneeRepresentativeSubject?: SubjectContactResponseDto;
    contactId?: number;
    contractRole?: string;
    cpCe?: HouseNumberType;
    email?: string;
    endDate?: string;
    ico?: string;
    id?: number;
    isConcerned?: boolean;
    isLpisUser?: boolean;
    jmeno?: string;
    lpisId?: number;
    mestskaCast?: string;
    modifiedAddress?: boolean;
    modifiedData?: boolean;
    nazev?: string;
    obec?: string;
    okres?: string;
    opsubType?: SubjectType;
    orderName?: string;
    paymentAddress?: boolean;
    payoutRent?: boolean;
    phone?: string;
    poznamka?: string;
    prijmeni?: string;
    psc?: string;
    representative?: boolean;
    representativeCount?: number;
    representativeNames?: string;
    rodneCislo?: string;
    startDate?: string;
    stat?: string;
    subjectContactPaymentDataList?: Array<SubjectContactPaymentDataDto>;
    subjectId?: number;
    subjectPartner1?: SubjectContactBaseResponseDto;
    subjectPartner2?: SubjectContactBaseResponseDto;
    subjectSource?: SubjectSource;
    subjectValidity?: string;
    taxConcerned?: boolean;
    titulPredJmenem?: string;
    titulZaJmenem?: string;
    ulice?: string;
    uliceKompletni?: string;
    userName?: string;
}
export namespace SubjectContactBaseResponseDto {
}


